import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { BlogService } from '../blogs/blog.service';
import { IBlog, BlogDetails } from '../blogs/blog';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
declare var $: any;
@Component({
  templateUrl: "./blogdetail.component.html"
})
export class BlogDetailComponent implements OnInit, AfterViewInit, OnDestroy  {
  public pageTitle: string = 'Blog Detail';
  p: number = 1;
  blogsList: IBlog[];
  iblob: IBlog[];
  blob: BlogDetails = new BlogDetails();
  slug: string;
  category: string;
  safeHtml: any;
  private sub: any;  
  constructor(private authService: AuthService,
    public blogService: BlogService,
    private route: ActivatedRoute,
    private appCommonService: AppCommonService,
    private sanitizer: DomSanitizer
  ) {
    this.appCommonService.pageContentAdditionalClass = "home-page main-page";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {      
      this.slug = params['slug'];
      this.category = params['category'];
      this.loadBlogsList(this.category);
      window.scrollTo(0, 0);
    });    
  }

  ngAfterViewInit() {
    
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  loadBlogsList(cat) {    
    this.blogService.getBlogsList(cat)
      .subscribe(
      (blogs: IBlog[]) => {                
        this.iblob = blogs.filter(b => b.slug == this.slug);
        this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.iblob[0].content.rendered);
        this.blogsList = blogs;
      },
      (error: any) => {
        this.blogService.showError("Blog retrieval problem", <any>error)
      }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/blogdetail.component.ts